<template>
  <b-img 
    blank
    :width="size" 
    :height="size" 
    rounded="circle" 
    :blank-color="hex" 
    :alt="title"
    :title="title"
    :class="className"
  />
</template>

<script>
export default {
    name: 'Headlight',
    props: ['size', 'hex', 'title', 'className'],
}
</script>
